import * as _ from 'lodash';

export let diff = (obj1, obj2) => {
  let diff = {};

  _.mapKeys(obj1, (value, key) => {
    if (!_.isEqual(value, obj2[key])) {
      diff[key] = obj2[key];
    }
  });

  return diff;
};
